import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FramedArtwork from '../components/FramedArtwork';

/**
 * /framed-artwork-demo
 *
 * Stand-alone showcase page for the FramedArtwork component. Drop into any
 * product page by passing your `imageSrc` and an `onAddToCart` handler.
 */
const FramedArtworkDemoPage = () => {
  const [lastChoice, setLastChoice] = useState(null);

  const handleAddToCart = (frameColour) => {
    setLastChoice(frameColour);
    // In a real shop this would dispatch to the cart slice + Stripe / API.
    // Dev-only breadcrumb for the demo page visitor.
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('Add to cart with frame colour:', frameColour);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-6xl mx-auto px-6 py-16 sm:py-24">
        <header className="mb-12">
          <p className="text-[11px] uppercase tracking-[0.3em] text-neutral-500 mb-3">
            Component preview
          </p>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-4">
            Choose your frame
          </h1>
          <p className="text-neutral-600 max-w-2xl">
            A drop-in replacement for the Electric Gallery frame picker —
            built with CSS variables, no canvas, no static frame images.
            Click a swatch to update the live preview, then add to cart.
          </p>
        </header>

        <FramedArtwork
          imageSrc="/api/media/artworks/Banksy_Girl_With_A_Balloon_Blue_7ff09e9a.jpg"
          imageAlt="Banksy — Girl with Balloon (Blue)"
          onAddToCart={handleAddToCart}
        />

        {lastChoice !== undefined && (
          <p
            className="mt-10 text-center text-sm text-neutral-500"
            data-testid="framed-artwork-demo-last-choice"
          >
            Last choice: <strong className="text-black">
              {lastChoice === null ? 'No Frame' : lastChoice}
            </strong>
          </p>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default FramedArtworkDemoPage;
